export default __webpack_public_path__ + "static/media/bg-01.dab965cc.jpg";